<template>
	<div :class='{"pc":!flag == true,"mobile":!flag == false}'>
		<div class="banner">
			<video src="../assets/chenxiaoshipin.mp4" controls="controls"></video>
			<img v-if="!flag" src="../assets/bannar-chengguo.png" alt="">
			<img class="banner-mobile" v-else src="../assets/bannar-chengguo-phone.png" alt="">
		</div>
		<div class="infoBox">
			<img src="../assets/qushi.png" alt="">
			<a href="https://mp.weixin.qq.com/s?__biz=MzA4NTE5MjIwOQ==&mid=2653358137&idx=1&sn=47b5371f712e278364db4fbe6de9112c&chksm=84081347b37f9a513f1df0258390bac0c5af4ed2768eaa1329a5cd0a39a1efefbead73f16f19&token=1038085655&lang=zh_CN#rd">
				<img class="bigImg" src="../assets/fazhanqushi.jpg" alt="">
				<div  style="margin-bottom: 80px;" class="ainfo">“粤字号”农业品牌发展趋势</div>
			</a>
			<img src="../assets/quyupinpai.png" alt="">
			<div class="pinPaiInfoBox">
				<a href="https://mp.weixin.qq.com/s?__biz=MzA4NTE5MjIwOQ==&mid=2653358151&idx=1&sn=af59ecf610e91effee118f3ed301deda&chksm=84081339b37f9a2f955c087f9a6712254953bc6666e7effd469ba3e5517c5025f1f66f9b096b&token=1038085655&lang=zh_CN#rd">
					<img src="../assets/damipinpai.jpg" alt="">
					<div class="ainfo">大米区域公用品牌</div>
				</a>
				<a href="https://mp.weixin.qq.com/s?__biz=MzA4NTE5MjIwOQ==&mid=2653358170&idx=1&sn=c67bbe9702817d9aabd0b6bb55099300&chksm=84081324b37f9a323d86cf63cf1bae76ca85359b15fe41b1c661fe253b9d285a01467afcff81&token=1038085655&lang=zh_CN#rd">
					<img src="../assets/shucai.jpg" alt="">
					<div class="ainfo">蔬菜区域公用品牌</div>
				</a>
				<a href="https://mp.weixin.qq.com/s?__biz=MzA4NTE5MjIwOQ==&mid=2653358191&idx=1&sn=9b6f2f8c794a7f2c45e65bc78cb4f578&chksm=84081311b37f9a07f56a3043f98ed4a2270dcf8962e9fdc944a40ba21c915a2ed9460fdbf614&token=1038085655&lang=zh_CN#rd">
					<img src="../assets/lizhipinpai.jpg" alt="">
					<div class="ainfo">荔枝区域公用品牌</div>
				</a>
				<a href="https://mp.weixin.qq.com/s?__biz=MzA4NTE5MjIwOQ==&mid=2653358206&idx=1&sn=e4b983bf032f8e9bf96fb7f05f6a6e02&chksm=84081300b37f9a169cb6bf79bca8d48d6e9ef4d1e9e52d758d263a323ddff12fbb2163567b65&token=1038085655&lang=zh_CN#rd">
					<img src="../assets/ganjuchengyou.jpg" alt="">
					<div class="ainfo">柑桔橙柚区域公用品牌</div>
				</a>
				<a href="https://mp.weixin.qq.com/s?__biz=MzA4NTE5MjIwOQ==&mid=2653358230&idx=1&sn=37c1084b0f863060e31caa8b433ab7f0&chksm=840813e8b37f9afe648fe09c59f02087ff4e06f3ee2b01b79ac781caf725d3f3429c42370692&token=1191473168&lang=zh_CN#rd">
					<img src="../assets/25shuiguo.png" alt="">
					<div class="ainfo">优稀水果区域公用品牌</div>
				</a>
				<a href="https://mp.weixin.qq.com/s?__biz=MzA4NTE5MjIwOQ==&mid=2653358245&idx=1&sn=850d397488ad8a5375f13a2dcbcd85d6&chksm=840813dbb37f9acd5636d11ee1f133c1c09f114cad61ccc3c6e7f854a00e31d03ed93bf78405&token=1191473168&lang=zh_CN#rd">
					<img src="../assets/26chaye.png" alt="">
					<div class="ainfo">茶叶区域公用品牌</div>
				</a>
				<a href="https://mp.weixin.qq.com/s?__biz=MzA4NTE5MjIwOQ==&mid=2653358252&idx=1&sn=c91363347d2bcde9e22bd64265a3ff41&chksm=840813d2b37f9ac410e621dcee410e176ceabea4ecf46b08f979201f19a5f538fdbf5b9e808e&token=1191473168&lang=zh_CN#rd">
					<img src="../assets/27zhongyaocai.png" alt="">
					<div class="ainfo">中药材区域公用品牌</div>
				</a>
				<a href="https://mp.weixin.qq.com/s?__biz=MzA4NTE5MjIwOQ==&mid=2653358254&idx=1&sn=84b7f28b97789abed3070fc84fb1c6b8&chksm=840813d0b37f9ac67d6a72b9f363e49c771c121e9bb2637cffe1f39e25efe7060674dd88d611&token=1191473168&lang=zh_CN#rd">
					<img src="../assets/28jiaqin.png" alt="">
					<div class="ainfo">家禽区域公用品牌</div>
				</a>
				<a href="https://mp.weixin.qq.com/s?__biz=MzA4NTE5MjIwOQ==&mid=2653358262&idx=1&sn=a002088d00871aad38a3c5f6fbd28cec&chksm=840813c8b37f9adee1eb4e8e2b438c7c493f930295faec8f2c39a9083e7cee89a5cbaa3ec830&token=1191473168&lang=zh_CN#rd">
					<img src="../assets/29shuichan.png" alt="">
					<div class="ainfo">水产品区域公用品牌</div>
				</a>

			</div>
			<img src="../assets/zuiyoujiazhi.png" alt="">
			<img class="bigImg" src="../assets/shidazuijujiazhi.jpg" alt="">
			<div class="info">
				原农业部党组成员、国务院参事室特约研究员、中国农产品市场协会会长 张玉香，广东省农业农村厅副厅长（正厅职）陈东为“粤字号”2019年度最有价值十大农产品区域公用品牌授牌。
			</div>
			<img src="../assets/quyupinpai.png" alt="">
			<img class="baiqiangImg" src="../assets/baiqiang1.png" alt="">
			<img  class="baiqiangImg" src="../assets/baiqiang2.png" alt="">
		</div>
		
	</div>
</template>
<script>
	export default {
		name: 'app',
		data() {
			return {
				flag: navigator.userAgent.match(
					/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
				)
			}
		},		
		methods: {
			
		},
		mounted() {
		
		}
	}
</script>

<style lang="scss" scoped="scoped">
	.pc{
		.banner{
			padding-top:500px;
			position: relative;
			height: 800px;
			img{
				position: absolute;
				left: 50%;
				top: 110px;
				margin-left: -960px;
			}
			video{
				position: absolute;
				width: 1200px;
				left: 50%;
				top: 500px;
				margin-left: -600px;
				z-index: 1;
				box-shadow: 0px 4px 14px #fffcd2;
				border: 1px solid red;
			}
		}
		.infoBox{
			margin-top: -100px;
			img{
				display: block;
				margin: 0 auto;
			}
			.bigImg{
				width: 800px;
				display: block;
				margin: 0 auto;
			}
			.pinPaiInfoBox{
				margin-bottom: 80px;
				a{
					display: inline-block;
					width:33%;
					padding: 20px;
					box-sizing: border-box;
					img{
						width: 100%;
						display: block;
						margin: 0 auto;
					}
				}
			}
			.info{
				margin: 0 auto;
				margin-top: 20px;
				margin-bottom: 80px;
				width: 800px;
				font-size: 18px;
				line-height: 34px;
				text-indent: 40px;
				text-align: justify;
			}
			.ainfo{
				margin: 0 auto;
				margin-top: 20px;
				font-size: 18px;
				line-height: 34px;
				text-align:center;
				text-indent: 0px;
				color: rgb(0,0,255);
			}
			.baiqiangImg{
				margin-left: -96px;
			}
		}
		
	}
	.mobile {
		width: 100%;
		height: 100%;
		margin-top: 1.302083rem;
		position: relative;
		overflow: hidden;
		.banner{
			width: 100%;
			position: relative;
			img{
				width: 100%;
				position: relative;
			}
			video{
				position: absolute;
				top: -40px;
				width: 100%;
				z-index: 1;
				box-shadow: 0px 4px 14px #fffcd2;
				border: 1px solid red;
				margin-top: 200px;
			}
		}
		.infoBox{
			padding: 10px;
			margin-top: -30px;
			font-size: 18px;
			line-height: 34px;
			text-align: justify;			
			img{
				width: 100%;
			}
			.info{
				text-indent: 40px;
				margin-bottom: 40px;
				margin-top: 18px;
			}
			.ainfo{
				margin: 0 auto;
				margin-top: 10px;
				margin-bottom: 40px;
				font-size: 18px;
				line-height: 30px;
				text-align:center;
				text-indent: 0px;
				color: rgb(0,0,255);
			}
		}
		.iframeS{
			width:100%;
			height:14720px;
		}
	}
</style>
